/* ==========================================================================
   rk-landing.js
   Vanilla JS for the Ronco landing-page section library.
   Zero dependencies. Loaded once by the last section on the page.

   Progressive enhancement: the CSS only hides .rk-reveal elements when the
   <html> element carries .rk-js, which this script adds. If this script does
   not run, content stays visible. New behaviours (accordions, tabs, etc.)
   should hang off data-rk-* attributes inside init() below.
   ========================================================================== */
(function () {
  'use strict';

  // Mark that JS is available, as early as possible, so the reveal styles
  // apply before first paint where possible (script is deferred, so this runs
  // after parse but the class still gates the animation correctly).
  document.documentElement.classList.add('rk-js');

  function reveal(el) { el.classList.add('rk-is-visible'); }

  function init() {
    var revealEls = document.querySelectorAll('.rk-reveal');
    if (!revealEls.length) return;

    // Honour reduced-motion: skip the observer, just show everything.
    var reduce = window.matchMedia &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    // No IntersectionObserver (old browsers) or reduced-motion → show all.
    if (reduce || !('IntersectionObserver' in window)) {
      revealEls.forEach(reveal);
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          reveal(entry.target);
          observer.unobserve(entry.target); // reveal once, then stop watching
        }
      });
    }, { rootMargin: '-60px 0px' });

    revealEls.forEach(function (el) { observer.observe(el); });
  }

  // Buy Now: opt-in per section via the "Add to cart via AJAX" setting.
  // Buttons are real <button> elements (not links), so without JS they
  // simply do nothing rather than navigating somewhere wrong — the
  // merchant-facing setting info note calls this out. This is a single-item
  // "buy now" flow, not a regular add-to-cart: it clears whatever's already
  // in the cart first, so checkout always reflects just this one item
  // rather than adding on top of an existing cart, then sends the customer
  // straight to checkout rather than leaving them on the page.
  function initAddToCart() {
    var buttons = document.querySelectorAll('[data-rk-add-to-cart]');
    if (!buttons.length) return;

    buttons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var variantId = btn.getAttribute('data-variant-id');
        if (!variantId) return;
        var originalLabel = btn.textContent;
        btn.disabled = true;
        btn.textContent = 'Adding…';

        fetch('/cart/clear.js', { method: 'POST' })
          .then(function () {
            return fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
            });
          })
          .then(function (res) {
            if (!res.ok) throw new Error('add to cart failed');
            return res.json();
          })
          .then(function () {
            document.dispatchEvent(new CustomEvent('rk:added-to-cart', { detail: { variantId: variantId } }));
            window.location.href = '/checkout';
          })
          .catch(function () {
            btn.textContent = 'Error — try again';
            setTimeout(function () {
              btn.textContent = originalLabel;
              btn.disabled = false;
            }, 1800);
          });
      });
    });
  }

  function initAll() {
    init();
    initAddToCart();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
